import { formatMoney, formatNumber } from '@tnn/core'
import { type ServiceLine, servicePerQuantity } from '@tnn/domain'

type T = (key: string, values?: Record<string, unknown>) => string

/** "1 บาท/5 กก. · ขั้นต่ำ 20": how a line of add-on services is priced, on a bill's form and on the printed bill */
export function servicePrice(line: ServiceLine, t: T) {
  const k = (key: string, values?: Record<string, unknown>) => t(`tms:service.line.${key}`, values)
  const rate = formatNumber(Number(line.rate) || 0)
  const price = {
    bill: k('perBill', { rate }),
    piece: k('perPiece', { rate }),
    weight: k('perWeight', { rate, step: formatNumber(Number(line.step) || 1) }),
  }[line.basis]
  return line.minimum ? `${price} · ${k('minimum', { amount: formatMoney(line.minimum) })}` : price
}

/** "40 กก.", "3 ชิ้น": the pieces or kg a line by the piece or weight is for; none for a line by the bill */
export function serviceQuantity(line: ServiceLine, t: T) {
  if (!servicePerQuantity(line) || line.quantity == null) return undefined
  return `${formatNumber(Number(line.quantity))} ${t(`tms:service.line.units.${line.basis}`)}`
}
